var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMorning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  d: "M19.647 27.096a9.4 9.4 0 0 1-7.85.096l-.234-.104a11.9 11.9 0 0 0-7.361-.756l-2.425.528a1 1 0 0 0-.755 1.185.983.983 0 0 0 1.166.767l2.425-.528a9.95 9.95 0 0 1 6.162.633l.235.104a11.33 11.33 0 0 0 9.468-.117 9.4 9.4 0 0 1 5.786-.742l3.573.68a.983.983 0 0 0 1.146-.797.997.997 0 0 0-.785-1.165l-3.572-.68a11.33 11.33 0 0 0-6.979.896"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  d: "M19.647 22.872a9.4 9.4 0 0 1-7.85.097l-.234-.105a11.9 11.9 0 0 0-7.361-.755l-2.425.528a1 1 0 0 0-.755 1.185.983.983 0 0 0 1.166.767l2.425-.528a9.95 9.95 0 0 1 6.162.632l.235.104a11.33 11.33 0 0 0 9.468-.116 9.4 9.4 0 0 1 5.786-.743l3.573.68a.984.984 0 0 0 1.146-.796.997.997 0 0 0-.785-1.165l-3.572-.68a11.33 11.33 0 0 0-6.979.895"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  d: "M13.054 23.424a6 6 0 1 0-9.147-1.25l.295-.065q.989-.215 1.99-.26a4 4 0 1 1 4.627.714q.376.138.744.301l.235.105q.616.273 1.256.454"
})));
export default SvgMorning;